import { I4BColumnConfiguration } from './configurations';
import { I4BColumn } from './definitions';
import { I4bCellConcept } from './enums';
import { I4BColumnHeader } from './models';
import { I4BColumnOptions } from './options';

type DefaultColumnsResolver = (concept: I4bCellConcept | string) => I4BColumn<I4BColumnHeader, I4BColumnConfiguration, I4BColumnOptions>[];

let resolver: DefaultColumnsResolver | null = null;

/**
 * Breaks the import cycle between `default-grids.definitions.ts` and the `default-*-grid.definition.ts` files:
 * grid files depend on this registry only, `default-grids.definitions.ts` registers the real resolver once evaluated.
 */
export const registerDefaultColumnsResolver = (columnsResolver: DefaultColumnsResolver): void => {
  resolver = columnsResolver;
};

export const getDefaultColumnsByConcept: DefaultColumnsResolver = (concept) => resolver?.(concept) ?? [];
